var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 17,
    fill: "white",
    stroke: "#D6D6DF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.167 11.0834C11.167 10.8533 11.3535 10.6667 11.5837 10.6667H17.4399C17.67 10.6667 17.8565 10.8533 17.8565 11.0834C17.8565 11.3135 17.67 11.5001 17.4399 11.5001H12.5896L25.3893 24.2995V19.4493C25.3893 19.2192 25.5759 19.0326 25.806 19.0326C26.0361 19.0326 26.2227 19.2192 26.2227 19.4493V25.3054C26.2227 25.5356 26.0361 25.7221 25.806 25.7221H19.9498C19.7197 25.7221 19.5331 25.5356 19.5331 25.3054C19.5331 25.0753 19.7197 24.8888 19.9498 24.8888H24.8001L12.0003 12.0893V16.9396C12.0003 17.1697 11.8138 17.3562 11.5837 17.3562C11.3535 17.3562 11.167 17.1697 11.167 16.9396V11.0834Z",
    fill: "#604099"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/Scale.e970e8022f1d3d59c96417b1643ba531.svg";
export { ForwardRef as ReactComponent };